import { Component } from '@angular/core';

@Component({
  selector: 'app-form-label',
  standalone: true,
  imports: [],
  templateUrl: './form-label.component.html',
  styleUrl: './form-label.component.scss'
})
export class FormLabelComponent {

}
